import List from 'containers/TransferOrder/List';
import Show from 'containers/TransferOrder/Show';
import Create from 'containers/TransferOrder/Create';
import Edit from 'containers/TransferOrder/Edit';
import BathDetail from 'containers/TransferOrder/Show/BathDetail';

export default { List, Show, Create, Edit, BathDetail };
